import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Outlet } from 'react-router-dom';
import './RequestSession.css';

function RequestSession() {
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedDuration, setSelectedDuration] = useState(''); // New state for session duration
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/courses`);
        setCourses(res.data);
      } catch (err) {
        console.error('Error fetching courses:', err);
        setError('Failed to load courses.');
      } finally {
        setLoading(false);
      }
    };
    fetchCourses();
  }, []);

  const handleCourseChange = (courseId) => {
    setSelectedCourse(courseId);
  };

  const handleDurationChange = (duration) => {
    setSelectedDuration(duration);
  };

  const handleSessionTypeChange = (type) => {
    if (selectedCourse && selectedDuration) {
      const sessionTypePath = type === 'online' ? 'online' : 'face-to-face';
      navigate(`${sessionTypePath}/${selectedCourse}/${selectedDuration}`);
    } else {
      setError('Please select both a course and a session duration.');
    }
  };

  if (loading) return <div>Loading courses...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  return (
    <div className="request-session-container">
      <h2>Request a Session</h2>
      {error && <p className="error">{error}</p>}
      {courses.length === 0 ? (
        <p className="no-courses">No courses available at the moment.</p>
      ) : (
        <div>
          <div className="course-selection">
            <label>Select a Course:</label>
            <select onChange={(e) => handleCourseChange(e.target.value)} value={selectedCourse}>
              <option value="">--Select a Course--</option>
              {courses.map(course => (
                <option key={course.id} value={course.id}>{course.name}</option>
              ))}
            </select>
          </div>

          {selectedCourse && (
            <div className="duration-selection">
              <label>Select Session Duration:</label>
              <select onChange={(e) => handleDurationChange(e.target.value)} value={selectedDuration}>
                <option value="">--Select Duration--</option>
                <option value="15">15 Minutes</option>
                <option value="30">30 Minutes</option>
                <option value="60">1 Hour</option>
                <option value="120">2 Hours</option>
                <option value="180">3 Hours</option>
              </select>
            </div>
          )}

          {selectedCourse && selectedDuration && (
            <div className="session-type-buttons">
              <button onClick={() => handleSessionTypeChange('online')}>Online</button>
              <button onClick={() => handleSessionTypeChange('face-to-face')}>Face-to-Face</button>
            </div>
          )}
        </div>
      )}
      <Outlet /> {/* Renders the nested session component */}
    </div>
  );
}

export default RequestSession;
